/** @jsx jsx */
// タブセレクターコンポーネント
import { FC } from 'react';
import { jsx, css } from '@emotion/core';
import { Tabs, Tab, Box } from '@material-ui/core';

const tabSelectorBox = css`
  display: flex;

  @media print {
    display: none;
  }
`;

interface TabSelectorProps {
  /** 選択されているタブのインデックス */
  selectedTab: number;
  /** タブのラベル配列 */
  tabLabels: string[];
  /** タブ変更時のコールバック */
  onTabChange: (index: number) => void;
  /** 外部から渡すスタイル */
  customCss?: string;
}

const TabSelector: FC<TabSelectorProps> = ({ selectedTab, tabLabels, onTabChange, customCss }) => {
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    onTabChange(newValue);
  };

  return (
    <Box css={tabSelectorBox}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        css={css`
          ${customCss}
        `}
      >
        {tabLabels.map((label, index) => (
          <Tab
            key={index}
            label={label}
            css={css`
              min-width: 140px;
              font-weight: ${selectedTab === index ? 'bold' : 'normal'};
            `}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default TabSelector;
